import { useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";

const rand = () => Math.floor(Math.random() * 9) + 1;

export const Captcha = ({ onChange, testid = "captcha" }) => {
  const [nums, setNums] = useState(() => [rand(), rand()]);
  const [val, setVal] = useState("");

  const handle = useCallback((e) => {
    const v = e.target.value;
    setVal(v);
    onChange(parseInt(v, 10) === nums[0] + nums[1]);
  }, [nums, onChange]);

  const refresh = () => {
    setNums([rand(), rand()]);
    setVal("");
    onChange(false);
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-chocolate mb-1.5">Anti-robot : combien font {nums[0]} + {nums[1]} ? *</label>
      <div className="flex items-center gap-2">
        <input
          data-testid={testid}
          type="number"
          value={val}
          onChange={handle}
          placeholder="Votre réponse"
          className="w-full rounded-2xl border border-beige bg-cream px-4 py-3 text-chocolate placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-strawberry/50 focus:border-strawberry transition"
        />
        <button type="button" onClick={refresh} data-testid={`${testid}-refresh`} aria-label="Nouveau calcul" className="shrink-0 h-12 w-12 rounded-2xl bg-white border border-beige flex items-center justify-center text-cocoa hover:text-strawberry transition">
          <RefreshCw size={18} />
        </button>
      </div>
    </div>
  );
};
